// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrencyInput_container__wSa9k"};